import { createAction, createReducer } from '@reduxjs/toolkit'

interface ReduxHeader {
   isSearchBoxFocused: boolean
   isLoginModalShown: boolean
}

const headerInitialState: ReduxHeader = {
   isSearchBoxFocused: false,
   isLoginModalShown: false,
}

const setLoginModalShown = createAction('LOGIN_MODAL_SHOWN')
const setLoginModalClosed = createAction('LOGIN_MODAL_CLOSED')
const setSearchBoxFocused = createAction('SEARCH_BOX_FOCUSED')
const setSearchBoxBlurred = createAction('SEARCH_BOX_BLURRED')

const headerReducer = createReducer(headerInitialState, (builder) => {
   builder.addCase(setSearchBoxFocused, (draft) => {
      draft.isSearchBoxFocused = true
   })
   builder.addCase(setSearchBoxBlurred, (draft) => {
      draft.isSearchBoxFocused = false
   })
   builder.addCase(setLoginModalShown, (draft) => {
      draft.isLoginModalShown = true
   })
   builder.addCase(setLoginModalClosed, (draft) => {
      draft.isLoginModalShown = false
   })

   return builder
})

export default headerReducer
